module.exports = __webpack_public_path__ + "img/DNARepair-BRCA_GSE176078.caaafb82.png";